// extracted by css-extract-rspack-plugin
export default {"teamRoleSelector":"glnEwyLNQagaDKlt"};